export const termsOfUseStorageKey = 'battery-monitoring:terms-of-use:v1';
const acceptedValue = 'accepted';

export const hasAcceptedTermsOfUse = (): boolean => {
  try {
    return globalThis.sessionStorage.getItem(termsOfUseStorageKey) === acceptedValue;
  } catch {
    return false;
  }
};

export const acceptTermsOfUse = (): void => {
  try {
    globalThis.sessionStorage.setItem(termsOfUseStorageKey, acceptedValue);
  } catch {
    // If storage is unavailable, keep the current in-memory acceptance only.
  }
};
